import React, { useState, useEffect } from "react";
import { Container, Form, Button, Row, Col } from "react-bootstrap";
import { ClipLoader } from "react-spinners";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import axios from "axios";

const ProductForm = () => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();
  const [products, setProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    // obtener el lot de la url por querystring
    const urlParams = new URLSearchParams(window.location.search);
    const lotParam = urlParams.get("lot");
    const productParam = urlParams.get("product");

    const errorParam = urlParams.get("error");

    if (lotParam) {
      setValue("lotNumber", lotParam);
    }

    if (productParam) {
      setValue("product", productParam);
    }

    if (errorParam && errorParam === "invalid-code") {
      setErrorMessage("Invalid security code.");
    }

    // Verifica si el código está en sessionStorage al cargar la página
    const storedCode = sessionStorage.getItem("sessionCode");
    if (storedCode) {
      setValue("code", storedCode);
    }

    // cargar combo productos
    const fetchProducts = async () => {
      try {

        setIsLoading(false);
      } catch (error) {
        //manejar error para mostrar en la vista que no sea un alerta
        setErrorMessage("An error occurred while fetching data.");
        setIsLoading(false);
        console.error(error);
      }
    };
    fetchProducts();
  }, []);

  useEffect(() => {
    const productSelected = sessionStorage.getItem("productSelected");
    if (productSelected) {
      setValue("product", productSelected);
    }
  }, [products]);

  const onSubmit = async (data) => {
    const { product, lotNumber, code } = data;
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/validate-code`,
        { code }
      );
      if (response.data.valid) {
        sessionStorage.setItem("sessionCode", code);
        sessionStorage.setItem("productSelected", product);
        navigate(`/products/${product}/lots/${lotNumber}`);
      } else {
        setErrorMessage("Invalid code.");
        setIsLoading(false);
      }
    } catch (error) {
      setErrorMessage("Error validating code: " + error.message);
      setIsLoading(false);
      console.error(error);
    }
  };

  const handleProductChange = (e) => {
    const selectedProduct = e.target.value;
    setValue("product", selectedProduct);
    sessionStorage.setItem("productSelected", selectedProduct);
  };

  return (
    <>
      <Container>
        <Row>
          <Col className="col-md-12">
            <img
              className="logo_blockbuddy"
              src="/logo_blockbuddy.png"
              alt="Logo de la Empresa"
            />
          </Col>
          {isLoading ? (
            <Row>
              <Col className="col-md-12 d-flex justify-content-center">
                <ClipLoader size={50} color={"#123abc"} loading={isLoading} />
              </Col>
            </Row>
          ) : (
            <>
              <Row className="justify-content-md-center">
                <Col md={6}>
                  <h1 className="info-title text-center">Transparent Supply</h1>

                  {errorMessage && (
                    <div className="alert alert-danger" role="alert">
                      {errorMessage}
                    </div>
                  )}
                  <Form onSubmit={handleSubmit(onSubmit)}>
                    <Form.Group controlId="product">
                      <Form.Label>Product Name</Form.Label>
                      <Form.Control
                        as="select"
                        {...register("product", {
                          required: "Product is required",
                        })}
                        onChange={handleProductChange}
                        isInvalid={!!errors.product}
                      >
                        <option value="">Select a product</option>
                        {products.map((product) => (
                          <option key={product.id} value={product.id}>
                            {product.description}
                          </option>
                        ))}
                      </Form.Control>
                      <Form.Control.Feedback type="invalid">
                        {errors.product && errors.product.message}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group controlId="lotNumber">
                      <Form.Label>Número de Lote</Form.Label>
                      <Form.Control
                        style={{ textTransform: "uppercase" }}
                        type="text"
                        {...register("lotNumber", {
                          required: "Lot number is required",
                        })}
                        isInvalid={!!errors.lotNumber}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.lotNumber && errors.lotNumber.message}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group controlId="code">
                      <Form.Label>Code</Form.Label>
                      <Form.Control
                        type="password"
                        {...register("code", { required: "Code is required" })}
                        isInvalid={!!errors.code}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.code && errors.code.message}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Button variant="primary" type="submit" block>
                      Search
                    </Button>
                  </Form>
                </Col>
              </Row>
            </>
          )}
        </Row>
      </Container>
    </>
  );
};

export default ProductForm;
